import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import { bindActionCreators } from 'redux';
import DeviceList from './DeviceList';
import {
  getSelectedView,
  getDevicesStatus,
  getDeviceIsLoading,
  getDevicesAlarms,
  getFlowSequenceSetpoints,
  getUserProfileWidget
} from '../../selectors/index';
import { fetchDevicesStatus, setSelectedView, getDeviceAlarmsThunk, devicesStatusSuccessThunk } from '../../actions/devices';
import { setSelectedUnit,setSelectedWarningUnit, setActiveDeviceTimezone } from '../../actions/devices';
import { setPageFilter } from '../../actions/alarms';
import { describeUnitThunk } from '../../actions/unitManager';
import { changeTimezone } from '../../actions/timezone';


const mapStateToProps = state => {
  return {
    devicesStatus: getDevicesStatus(state),
    selectedView: getSelectedView(state),
    deviceAlarms: getDevicesAlarms(state),
    flowSequences: getFlowSequenceSetpoints(state),
    userProfileWidgets: getUserProfileWidget(state),
    isDeviceListLoading: getDeviceIsLoading(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      redirect: location => push(location),
      setSelectedUnit: unitSerialNumber => setSelectedUnit(unitSerialNumber),
      setSelectedWarningUnit: unitSerialNumber => setSelectedWarningUnit(unitSerialNumber),
      changeTimezone: timezone => changeTimezone(timezone),
      describeUnit: (unitSerialNumber, widgetCode) => describeUnitThunk(unitSerialNumber, widgetCode, true),
      resetDevicetimezone: () => setActiveDeviceTimezone(''),
      getDevicesStatus: (unitSerialNumbers, from, to) => fetchDevicesStatus(unitSerialNumbers, from, to, 'MYUNITSINDASHBOARD'),
      resetDeviceStatus: initialDeviceStatus => devicesStatusSuccessThunk(initialDeviceStatus),
      setSelectedUnitView: tabName => setSelectedView(tabName),
      setAlarmsPageFilter: filter => setPageFilter(filter),
      getDeviceAlarms: (unitSerialNumbers, status) => getDeviceAlarmsThunk(unitSerialNumbers, status, 'MYUNITSINDASHBOARD')
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DeviceList);
